export default __webpack_public_path__ + "static/testi-5-40110cca418473c64e9fbcf8aa5c50cd.png";